// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#resident-edit[data-v-650f9849]{max-width:700px;margin-left:auto;margin-right:auto}#resident-edit .delete-btn[data-v-650f9849]{font-size:14px!important;width:50px;height:24px!important}#resident-edit .add-btn[data-v-650f9849]{width:70px}#resident-edit .cancel-btn[data-v-650f9849],#resident-edit .update-btn[data-v-650f9849]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
